<dynamic-form-v2 
    *ngIf="!isLoading" 
    entityType="qa-users" 
    [formName]="title" 
    [(record)]="qaUserRecord"
    [fields]="fields"
    [viewRoute]="viewRoute"
>
</dynamic-form-v2>